module.exports = __webpack_public_path__ + "static/media/logo.bbca0169.png";